import { AllocatedPlaceInput } from '../../lib/types/models/trip-booking/trip-date-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type TripBookingsAllocationToCenterRequestInput = {
  id: number
  data: AllocatedPlaceInput[]
}

export function updatedAllocatedPlaces(input: TripBookingsAllocationToCenterRequestInput) {
  const { id, data } = input
  return restApiClient
    .url(constructApiUrl(API.tripDates.updateAllocatedPlaces.url, { id }))
    .patch<never, AllocatedPlaceInput[]>(data)
}
